var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#ballpen';
                    var viewUrl = 'svg/icons.svg#view-ballpen';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };